import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Tooltip from '../../../../../../Tooltip';
import InteractiveButton from '../../../../../../InteractiveButton/InteractiveButton';
import IconGear from '../../../../../../Icons/IconGear/IconGear';
import { ElementSize } from '../../../../../../../types/element-size';
import { useChartPreferencesInteractor } from './interactor';
import CycleMeasurement from '../../../../../../../enums/cycle-measurement';
import { LiveChartPreferences, PreferencesTempRange } from './LiveChartPreferences';

export interface ChartPreferencesWrapperProps {
  cycleId: string;
  measurement: CycleMeasurement;
  tempRange: PreferencesTempRange;
}

export const ChartPreferencesWrapper = (props: ChartPreferencesWrapperProps) => {
  const { cycleId, measurement, tempRange } = props;
  const [isEditChartPreferences, setIsEditChartPreferences] = useState<boolean>(false);

  const { settings, canEdit } = useChartPreferencesInteractor({ cycleId });

  const { t } = useTranslation();

  const openModalChartPreferences = () => {
    setIsEditChartPreferences(true);
  };

  const closeModalChartPreferences = () => {
    setIsEditChartPreferences(false);
  };

  if (!canEdit) {
    return null;
  }

  return (
    <>
      <Tooltip hint={t('labels.chartSettings')} hintClassName="left-[50%] bottom-9">
        <InteractiveButton
          onClick={openModalChartPreferences}
          customType="max-h-fit max-w-fit border border-foggy-mist rounded active:border-primary cursor-pointer min-w-fit"
          style={{ padding: ' 0px 12px' }}
        >
          <IconGear stroke="inherit" iconClassName="text-inherit" size={ElementSize.XS} />
        </InteractiveButton>
      </Tooltip>

      {settings && (
        <LiveChartPreferences
          cycleId={cycleId}
          isVisible={isEditChartPreferences}
          onOpen={openModalChartPreferences}
          onClose={closeModalChartPreferences}
          chartPreference={settings}
          measurement={measurement}
          currentTempRange={tempRange}
        />
      )}
    </>
  );
};
